export function patchForm(
  form: HTMLFormElement,
  model: Record<string, string | number | null | undefined>,
): void {
  for (const key in model) {
    if (model[key] === null || model[key] === undefined) {
      continue;
    }
    if (typeof model[key] === "object") {
      throw new Error(
        "Modify the model so that it does not contain complex objects before patching the form.",
      );
    }
    const control = form.elements.namedItem(key);
    if (control instanceof HTMLInputElement && control.type === "checkbox") {
      control.checked = model[key] !== "0" && !!model[key];
    } else if (control instanceof HTMLInputElement) {
      control.value = model[key]?.toString();
    } else if (control instanceof RadioNodeList) {
      control.value = model[key]?.toString();
    } else if (control instanceof HTMLTextAreaElement) {
      control.value = model[key]?.toString();
    } else if (
      control instanceof HTMLSelectElement &&
      [...control.options].some((o) => o.value === model[key]?.toString())
    ) {
      control.value = model[key]?.toString();
    } else if (control && "value" in control) {
      control.value = model[key];
    }
  }
}
